export const DashboardSection = {
  DEVICES: "devices",
  ASSEMBLIES: "assemblies",
  TEST_FIXTURES: "test-fixtures",
  FIRMWARE_UPDATES: "firmware-updates",
  ANALYTICS: "analytics",
};
